import { useState, useEffect, useCallback } from "react";
import {
  IPerformanceMetricComments,
  UserInterface,
  ICountry,
} from "../../../interface";
import CountryFilter from "../../../components/CountryFilter";
import { Category } from "../../../interface/Enums/category.enum";
import { PerfType } from "../../../interface/Enums/peftype.enum";
import { useDispatch, useSelector } from "react-redux";
import { getAllCountries } from "../../../APIs";
import { fetchAPI } from "../../../utils/FetchApi";
import { FetchMethods } from "../../../interface/Enums/methods.enum";
import { setError } from "../../../store/reducers/errorReducer";
import Dropdown from "react-bootstrap/Dropdown";
import { BsThreeDotsVertical } from "react-icons/bs";
import Badge from "react-bootstrap/Badge";
import Accordion from "react-bootstrap/Accordion";
import { BsPerson } from "react-icons/bs";
import AdminContainer from "../../../admin-components/AdminContainer";
import { Modal, BtnCreate } from "../../../components/StyledComponents";
const ManagePerformanceCommentsMetric = () => {
  const dispatch: any = useDispatch();
  const data: UserInterface = useSelector((data: any) => {
    return data.auth.user;
  });
  const makeEmpty: IPerformanceMetricComments = {
    name: "",
    explanation: "",
    category: Category.COMMENTS,
    type: PerfType.STANDARD,
    country: "",
    createdAt: new Date(),
    updatedAt: new Date(),
    creator: data.name + " " + data.surname,
  };

  const [listOfCountries, setlistOfCountries] = useState<ICountry[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>("");
  const [performanceMetrics, setPerformanceMetrics] = useState<
    IPerformanceMetricComments[]
  >([]);
  const [reloadAllData, setReloadAllData] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [formData, setFormData] = useState<IPerformanceMetricComments>(makeEmpty);

  const openModal = (editMode: boolean = false, metric?: IPerformanceMetricComments) => {
    setIsEditMode(editMode);
    setFormData(editMode && metric ? metric : makeEmpty);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setIsEditMode(false);
    setFormData(makeEmpty);
  };

  const handleInputChange = (field: keyof IPerformanceMetricComments, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    // Validation
    if (
      formData.name.length === 0 ||
      formData.country.length === 0 ||
      formData.explanation.length === 0
    ) {
      dispatch(setError("Name, country and explanation is required"));
      return;
    }

    try {
      if (isEditMode) {
        await fetchAPI(
          "/admincmds/update-performance-comments-metric",
          FetchMethods.PATCH,
          formData
        );
      } else {
        await fetchAPI(
          "/admincmds/create-performance-comments-metric",
          FetchMethods.POST,
          formData
        );
      }
      closeModal();
      setReloadAllData(!reloadAllData);
    } catch (error: any) {
      dispatch(setError(error.message.toString()));
    }
  };

  const deletePerformanceMetric = async (index: number) => {
    try {
      const listOfAllInputs: IPerformanceMetricComments[] = await fetchAPI(
        `/admincmds/delete-performance-comments-metric/${performanceMetrics[index]._id}`,
        FetchMethods.GET
      );
      if (listOfAllInputs.hasOwnProperty("error")) {
        //@ts-ignore
        throw new Error(listOfAllInputs.message?.toString());
      }
      setReloadAllData(!reloadAllData);
    } catch (error: any) {
      dispatch(setError(error.toString()));
    }
  };
 

  const pickCountry = useCallback(
    (country: string): void => {
      setSelectedCountry(country);
    },
    []
  );

  /**
   * Use Effects
   */
  useEffect(() => {
    (async () => {
      const ctries: ICountry[] = await getAllCountries();
      ctries.sort((a, b) => (a.name > b.name ? 1 : -1));
      setlistOfCountries(ctries);
    })();
  }, [reloadAllData]);

  //Load all inputs based on the country
  useEffect(() => {
    if (selectedCountry.length > 0) {
      (async () => {
        try {
          const getAllInputs: IPerformanceMetricComments[] = await fetchAPI(
            `/admincmds/get-all-performance-comments-metrics/${selectedCountry}`,
            FetchMethods.GET
          );
          if (getAllInputs.hasOwnProperty("error")) {
            throw new Error(JSON.stringify(getAllInputs));
          }
          setPerformanceMetrics(getAllInputs);
        } catch (error: any) {
          dispatch(JSON.stringify(error.message));
        }
      })();
    }

    //do nothing yet
  }, [selectedCountry, reloadAllData, dispatch]);
  //hlídej to zasraný jméno
  useEffect(() => {
    setFormData((p) => ({
      ...p,
      creator: data.name + " " + data.surname,
    }));
  }, [data]);
  return (
    <AdminContainer>
      <div className="row justify-content-between align-items-center">
        <div className="col-lg-8 m-2">
          <CountryFilter returnedCountry={pickCountry} />
        </div>
        <div className="col-lg-2 m-2">
  
          <BtnCreate onClick={() => openModal(false)}>
            Create new Performance Metric
          </BtnCreate>
        </div>
      </div>
      <hr className="hr" />
      <div className="row justify-content-md-center">
        {performanceMetrics.map((c: IPerformanceMetricComments, i: number) => (
          <div className="card col-lg-5 m-2 p-4 shadow rounded" key={i}>
            <div className="row">
              <div className="col-lg-2">
                <Dropdown>
                  <Dropdown.Toggle size="sm" variant="info">
                    <BsThreeDotsVertical />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      href="#/action-1"
                      onClick={() => openModal(true, performanceMetrics[i])}
                    >
                      Update
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#/action-2"
                      onClick={() => {
                        deletePerformanceMetric(i);
                      }}
                    >
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="col-lg-10">
                <Badge
                  bg={c.category === "input" ? "secondary" : "warning"}
                  className="mr-2"
                >
                  {c.category}
                </Badge>
                <Accordion>
                  <Accordion.Item eventKey={i.toString()}>
                    <Accordion.Header>
                      <BsPerson />
                      {"   "}
                      <small className="m-2" style={{ fontWeight: "bold" }}>
                        {c.name}
                      </small>
                    </Accordion.Header>
                    <Accordion.Body key={i}>
                      <strong>Explanation:</strong>
                      <p>{c.explanation}</p>
                      <br />
                      <Badge bg="secondary">By: {c.creator}</Badge>
                      <br />
                      <Badge bg="secondary">Country scope: {c.country}</Badge>
                      <br />
                      <Badge bg="secondary">Category: {c.category}</Badge>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        ))}
      </div>
      {
        // Create a performance metric
      }
      {showModal && (
        <Modal isOpen={showModal} onClose={closeModal} title={isEditMode ? "Update Performance Metric" : "Create Performance Metric"}>
          <div className="row w-full justify-content-center">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              <div className="row" style={{ marginTop: 100 }}>
                <div className="form-group">
                    <div className="card" style={{ padding: 30 }}>
                      <div className="row p-4 m-4 shadow rounded">
                        <div className="col-4">
                          <h3>Metric Name</h3>
                        </div>
                        <div className="col-6">
                          <input
                            className="form-control"
                            type="text"
                            value={formData.name}
                            onChange={({ target }) => handleInputChange('name', target.value)}
                          />
                        </div>
                      </div>

                      <div className="row p-4 m-4 shadow rounded">
                        <div className="col-4">
                          <h3>Metric Explanation</h3>
                        </div>
                        <div className="col-6">
                          {" "}
                          <input
                            className="form-control"
                            type="text"
                            value={formData.explanation}
                            onChange={({ target }) => handleInputChange('explanation', target.value)}
                          />
                        </div>
                      </div>

                      <div className="row p-4 m-4 shadow rounded">
                        <div className="col-4">
                          <h3>Country</h3>
                        </div>
                        <div className="col-6">
                          <select
                            className="form-control"
                            value={formData.country}
                            onChange={({ target }) => handleInputChange('country', target.value)}
                          >
                            <option className="form-control" value="">
                              ---
                            </option>
                            {listOfCountries.map((c: ICountry, i: number) => (
                              <option
                                className="form-control"
                                key={i}
                                value={c.name}
                              >
                                {c.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col p-4 m-4 shadow rounded">
                        <h3 className="text-center">Creator</h3>
                        <input
                          className="form-control"
                          type="text"
                          readOnly
                          value={formData.creator}
                          style={{
                            backgroundColor: "#d6d6d6",
                            textAlign: "center",
                          }}
                        />
                      </div>

                      <div className="row">
                        {" "}
                        <button type="submit" className="dai-btn dai-btn-success">
                          {isEditMode ? "Update" : "Create"}
                        </button>
                      </div>
                    </div>
                </div>
              </div>
            </form>
          </div>
          </Modal>
      )}
    </AdminContainer>
  );
};

export default ManagePerformanceCommentsMetric;
